import React, { useState, useRef, useEffect, useContext } from "react";
import api from "../API/axiosInstance";
import { Link } from "react-router-dom";
import wide from "../images/cdac-logo-wide.png";
// import "./../styles/Signin.css";
// import "./../styles/gradient.css";
import { useNavigate } from "react-router-dom";
import { jwtDecode } from "jwt-decode";
// import jwtDecode from "jwt-decode"; // Corrected import statement
import { toast } from "react-toastify"; // Import Toastify
// import "./../styles/gradient.css";
import SimpleCaptcha from "./SimpleCaptcha";
// import "../styles/DecoyLogin.css";
import "../styles/AddUserNew.css";
import { generateHash } from "../API/hashUtil";
import NavBar from "./Admin/Dashboard/NavBar";
import ReactProSidebar from "./Admin/Dashboard/ReactProSidebar";
import { MyContext } from "../MyContextApi";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";
import CustomRoleSelect from "./CustomDropdown";
import CustomAlertDialog from "./Dialog";

const USERNAME_REGEX = /^[a-zA-Z0-9_@#]{3,20}$/;

const PWD_REGEX =
  /^(?!.*<script>)(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*(),.?":{}|<>]).{8,20}$/;

const apiUrl = process.env.REACT_APP_BASE_API_URL;
const LOGIN_URL = "/user/signup";
const AddUser = () => {
  const { captchaData, setCaptchaData } = useContext(MyContext);
  const userRef = useRef();
  const errRef = useRef();
  const [userName, setUserName] = useState("");
  const [userEmail, setUserEmail] = useState("");
  const [userContactno, setUserContactno] = useState("");
  const [validUserName, setValidUserName] = useState(false);
  const [confirmPassword, setconfirmPassword] = useState("");
  const [password, setPassword] = useState("");
  const [validPassword, setValidPassword] = useState(false);
  const [role, setRole] = useState(""); // State for role
  const [userCaptchaInput, setUserCaptchaInput] = useState("");
  const [errors, setErrors] = useState({});
  const navigate = useNavigate();
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [refreshTrigger, setRefreshTrigger] = useState(false);
  const [successDialogOpen, setSuccessDialogOpen] = useState(false);

  // const validateNewPassword = (password) => {
  //   if (!passwordRegex.test(password)) {
  //     setErrors(
  //       "Password must be 8-20 characters, include uppercase, lowercase, number, special character, and not contain '<script>'."
  //     );
  //     return false;
  //   }
  //   setErrors("");
  //   return true;
  // };

  useEffect(() => {
    if (userRef.current) {
      userRef.current.focus();
    }
  }, []);

  useEffect(() => {
    setValidUserName(USERNAME_REGEX.test(userName));
  }, [userName]);

  useEffect(() => {
    setValidPassword(PWD_REGEX.test(password));
  }, [password]);

  const handleOption = (e) => {
    //
    setRole(e.target.value);
  };

  const handleSuccessDialogClose = () => {
    setSuccessDialogOpen(false);
    window.location.reload();
  };
  //
  //
  const validateCaptcha = async () => {
    try {
      // Same captcha validation flow as SignIn page
      const response = await api.post("/captcha2/validate", {
        captchaId: captchaData.captchaId,
        captcha: userCaptchaInput,
      });

      return response.status === 200;
    } catch (error) {
      toast.error("Invalid captcha. Please try again.");

      // Refresh captcha image
      setRefreshTrigger((prev) => !prev);

      return false;
    }
  };

  const handleSignIn = async (e) => {
    e.preventDefault();

    if (!captchaData?.captchaImage || !captchaData?.captchaId) {
      toast.error("Please complete the captcha.");
      return;
    }

    const isCaptchaValid = await validateCaptcha();
    if (!isCaptchaValid) return;

    // if (!validateNewPassword(password)) return;

    const validationErrors = {};

    // Password length validation

    // Password regex validation
    if (!PWD_REGEX.test(password)) {
      validationErrors.password =
        "Password must be 8-20 characters, include uppercase, lowercase, number, special character, and not contain '<script>'.";
    }

    // Confirm password validation
    if (password !== confirmPassword) {
      validationErrors.confirmPassword = "Passwords do not match.";
    }

    // Contact number validation
    if (!/^\d{10}$/.test(userContactno)) {
      validationErrors.contactno = "Contact no. should be 10 digits.";
    }

    // If there are validation errors, set them and return
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }

    setErrors({});

    const username = userName;
    const email = userEmail;
    const phoneNo = userContactno;
    let stringParams = {
      username: username ? username.toString() : "",
      password: password ? password.toString() : "",
      email: email ? email.toString() : "",
      phoneNo: phoneNo ? phoneNo.toString() : "",
      role: role ? role.toString() : "",
    };

    const HPPcode = generateHash(stringParams);

    //
    try {
      //
      const token = localStorage.getItem("Token");

      const response = await api.post(
        LOGIN_URL,
        JSON.stringify({ username, password, email, phoneNo, role, HPPcode }), // Include role
        {
          headers: {
            "Content-Type": "application/json",
            // Security Headers
            "X-XSS-Protection": "1; mode=block",
            Authorization: `Bearer ${token}`,
            "X-Content-Type-Options": "nosniff",
            "X-Frame-Options": "DENY",
            "Referrer-Policy": "strict-origin-when-cross-origin",
            "Permissions-Policy": "camera=(), microphone=(), geolocation=()",
          },
          withCredentials: true,
        },
      );

      //

      // setIsLoggedIn(true);

      setUserName("");
      setPassword("");
      setconfirmPassword("");
      setUserEmail("");
      setUserContactno("");
      setRole("");
      // token = response.data.token;
      // const decodedToken = jwtDecode(token);
      // const userRole = decodedToken.role[0];

      // localStorage.setItem("LogIn", true);
      // localStorage.setItem("LogOut", false);
      // localStorage.setItem("Token", token);
      // localStorage.setItem("User_Role", userRole);

      // setUserDetails(decodedToken);

      setSuccessDialogOpen(true);
      //
    } catch (err) {
      console.error("Error occurred:", err);
      if (!err?.response) {
        toast.error("No Server Response", {
          position: "top-right",
          autoClose: 5000,
        });
      } else if (err.response?.status === 400) {
        toast.error("email is already taken!", {
          autoClose: 5000,
          position: "top-right",
        });
      } else if (err.response?.status === 403) {
        toast.error("User is not approved by admin", {
          autoClose: 5000,
          position: "top-right",
        });
      } else {
        toast.error("server error", {
          autoClose: 5000,
          position: "top-right",
        });
        alert("server error");
      }
      errRef.current?.focus();
    }
  };

  return (
    <div className="container">
      {/* Navbar */}
      <NavBar />
      <CustomAlertDialog
        open={successDialogOpen}
        onConfirm={handleSuccessDialogClose}
        title="User Created"
        message="User has been created successfully."
        iconType="info"
        buttonText="OK"
      />
      <main>
        <div className="adduser-form-wrapper">
          {/* <ToastContainer className="adduser-toast-container" /> */}

          <div className="adduser-header-section">
            <h2 className="adduser-title-main">Add New User</h2>
            <p className="adduser-subtitle-text">
              Create and configure user accounts with precision and elegance.
              Assign roles, set permissions and manage access.
            </p>
          </div>

          <div className="adduser-form-content">
            <form
              id="adduser-form-element"
              onSubmit={handleSignIn}
              className="adduser-form-element"
              autoComplete="off"
            >
              {/* Row 1: User Name and Email */}
              <div className="adduser-field-row">
                <div className="adduser-input-group">
                  <label htmlFor="user_id" className="adduser-field-label">
                    User Name
                  </label>
                  <input
                    className="adduser-text-input"
                    type="text"
                    value={userName}
                    onChange={(e) => setUserName(e.target.value.replace(/\s/g, ""))}
                    id="user_id"
                    name="user_id"
                    placeholder="Enter username"
                    required
                    autoComplete="off"
                  />
                  {errors.username && (
                    <p className="adduser-error-message">{errors.username}</p>
                  )}
                </div>
                <div className="adduser-input-group">
                  <label htmlFor="email" className="adduser-field-label">
                    Email
                  </label>
                  <input
                    className="adduser-text-input"
                    type="email"
                    value={userEmail}
                    onChange={(e) => setUserEmail(e.target.value)}
                    id="email"
                    name="email"
                    placeholder="Enter Email"
                    required
                    autoComplete="off"
                  />
                </div>
              </div>

              {/* Row 2: Contact no. and Role */}
              <div className="adduser-field-row">
                <div className="adduser-input-group">
                  <label htmlFor="contactno" className="adduser-field-label">
                    Contact no.
                  </label>
                  <input
                    className="adduser-text-input"
                    type="text"
                    value={userContactno}
                    onChange={(e) => setUserContactno(e.target.value)}
                    id="contactno"
                    name="contactno"
                    placeholder="Enter Contact no."
                    required
                    autoComplete="off"
                  />
                  {errors.contactno && (
                    <p style={{ color: "red" }} className="error">
                      {errors.contactno}
                    </p>
                  )}
                </div>
                <CustomRoleSelect
                  value={role}
                  onChange={handleOption}
                  required
                />
              </div>
              <div className="adduser-field-row">
                <div className="adduser-input-group">
                  <label htmlFor="password" className="adduser-field-label">
                    Password
                  </label>
                  <div
                    style={{
                      position: "relative",
                      display: "inline-block",
                      width: "100%",
                    }}
                  >
                    <input
                      className="adduser-text-input"
                      type={showPassword ? "text" : "password"}
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                      id="password"
                      name="password"
                      placeholder="Enter Password"
                      required
                      style={{ paddingRight: "40px" }}
                      autoComplete="off"
                    />
                    <button
                      type="button"
                      onClick={() => setShowPassword(!showPassword)}
                      style={{
                        position: "absolute",
                        right: "12px",
                        top: "50%",
                        transform: "translateY(-50%)",
                        background: "none",
                        border: "none",
                        cursor: "pointer",
                        color: "#666",
                        fontSize: "16px",
                        padding: "0",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        width: "20px",
                        height: "20px",
                      }}
                      aria-label={
                        showPassword ? "Hide password" : "Show password"
                      }
                    >
                      <FontAwesomeIcon
                        icon={showPassword ? faEyeSlash : faEye}
                      />
                    </button>
                  </div>
                  {errors.password && (
                    <p className="adduser-error-message">{errors.password}</p>
                  )}
                </div>
                <div className="adduser-input-group">
                  <label
                    htmlFor="confirmPassword"
                    className="adduser-field-label"
                  >
                    Confirm Password
                  </label>
                  <div
                    style={{
                      position: "relative",
                      display: "inline-block",
                      width: "100%",
                    }}
                  >
                    <input
                      className="adduser-text-input"
                      type={showConfirmPassword ? "text" : "password"}
                      value={confirmPassword}
                      onChange={(e) => setconfirmPassword(e.target.value)}
                      id="confirmPassword"
                      name="confirmPassword"
                      placeholder="Confirm Password"
                      required
                      style={{ paddingRight: "40px" }}
                      autoComplete="off"
                    />
                    <button
                      type="button"
                      onClick={() =>
                        setShowConfirmPassword(!showConfirmPassword)
                      }
                      style={{
                        position: "absolute",
                        right: "12px",
                        top: "50%",
                        transform: "translateY(-50%)",
                        background: "none",
                        border: "none",
                        cursor: "pointer",
                        color: "#666",
                        fontSize: "16px",
                        padding: "0",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        width: "20px",
                        height: "20px",
                      }}
                      aria-label={
                        showConfirmPassword ? "Hide password" : "Show password"
                      }
                    >
                      <FontAwesomeIcon
                        icon={showConfirmPassword ? faEyeSlash : faEye}
                      />
                    </button>
                  </div>
                  {errors.confirmPassword && (
                    <p className="adduser-error-message">
                      {errors.confirmPassword}
                    </p>
                  )}
                </div>
              </div>

              {/* Row 4: Captcha and Enter Captcha */}
              <div className="adduser-field-row">
                <div className="adduser-input-group">
                  <label htmlFor="captcha" className="adduser-field-label">
                    Captcha
                  </label>
                  {/* <div className="adduser-captcha-container"> */}
                  <SimpleCaptcha
                    onCaptchaChange={setCaptchaData}
                    refreshTrigger={refreshTrigger}
                  />
                  {/* </div> */}
                </div>
                <div className="adduser-input-group">
                  <label htmlFor="captchaInput" className="adduser-field-label">
                    Enter Captcha
                  </label>
                  <input
                    className="adduser-text-input adduser-captcha-input"
                    type="text"
                    value={userCaptchaInput}
                    onChange={(e) => {
                      setUserCaptchaInput(e.target.value);
                    }}
                    id="captchaInput"
                    name="captchaInput"
                    placeholder="Enter CAPTCHA"
                    required
                    autoComplete="off"
                  />
                  {errors.captcha && (
                    <p className="adduser-error-message">{errors.captcha}</p>
                  )}
                </div>
              </div>

              <button type="submit" className="adduser-submit-btn">
                Add User
              </button>
            </form>
          </div>
        </div>
      </main>
      <ReactProSidebar />
    </div>
  );
};

export default AddUser;
